export default __webpack_public_path__ + "static/media/trade-mark.0bcfd5ac.svg";